<template>
  <el-dialog
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    center
    :visible="true"
    :before-close="handleClose"
  >
    <div class="wrapper">
      <div class="loading-section" v-if="loading">
        <div>
          <img src="/img/frameloader.gif" width="48" />
        </div>
        <div class="p-top-20">
          {{ $t('Sites_ExportDialog_Text_ExportingData') }}
        </div>
        <div class="p-top-50">
          <div>{{ $t('Sites_ExportDialog_Text_Question') }}</div>
          <div>{{ $t('Sites_ExportDialog_Text_Description') }}</div>
        </div>
      </div>
      <div class="download-section" v-else>
        {{ $t('Sites_ExportDialog_Text_ExportIsReady') }}
      </div>
    </div>
    <div slot="footer">
      <el-button v-if="loading" type="primary" plain @click="handleClose">
        {{ $t('Sites_ExportDialog_Button_CheckLater') }}
      </el-button>
      <el-button v-else type="primary" @click="download">
        {{ $t('Sites_ExportDialog_Button_Download') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios/index'
import { baseUrl, projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'ExportDialog',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  mounted() {
    this.taskLoop = setInterval(() => {
      this.fetchTask()
    }, 2000)
  },
  data() {
    return {
      task: {},
      taskLoop: null
    }
  },
  computed: {
    loading() {
      return !(this.task.hasOwnProperty('status') && this.task.status === 2)
    },
    fileUrl() {
      if (this.task.hasOwnProperty('status') && this.task.status === 2) {
        return `${baseUrl()}file/private/download?id=${this.task.task.file.id}`
      }
      return null
    },
    fileName() {
      if (this.task.hasOwnProperty('status') && this.task.status === 2) {
        return `${this.task.task.file.name}.csv`
      }
      return null
    }
  },
  methods: {
    download() {
      axios
        .get(this.fileUrl, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = this.fileName
          link.click()
          URL.revokeObjectURL(link.href)
          this.handleClose()
        })
        .catch(console.error)
    },
    fetchTask() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `task-histories/${this.taskId}?expand=task`
        })
      ).then(({ data }) => {
        this.task = data
      })
    },
    handleClose() {
      clearInterval(this.taskLoop)
      EventBus.$emit('export-dialog-hide')
    }
  },
  watch: {
    'task.status': {
      handler() {
        switch (this.task.status) {
          case 2:
            clearInterval(this.taskLoop)
            break

          case 3:
            this.$message({
              message: this.$t('Sites_ExportDialog_Alert_Error'),
              type: 'error'
            })
            this.handleClose()
            break

          case 4:
            this.$message({
              message: this.$t('Sites_ExportDialog_Alert_Fatal'),
              type: 'error'
            })
            this.handleClose()
            break
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.wrapper {
  text-align: center;
  .loading-section {
    padding: 20px;
  }
  .download-section {
    margin: 100px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/sites/components/ExportDialog.vue